module.exports = __webpack_public_path__ + "img/Frisur.ef315e8c.jpg";